import { render, staticRenderFns } from "./CityCategoryForm.vue?vue&type=template&id=4b27ef93"
import script from "./CityCategoryForm.vue?vue&type=script&lang=ts"
export * from "./CityCategoryForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports